export default "__VITE_ASSET__5JB6_vM5__"